import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const Messages = () => {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const fetchcontacts = async () => {
      try {
        const res = await axios.get('/api/contacts');
        setContacts(res.data);
      } catch (error) {
        console.error('Error fetching members:', error);
      }
    };

    fetchcontacts();
  }, []);

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.headerRow}>
        <div>
          <h2 style={styles.pageTitle}>User Messages</h2>
          <p style={styles.pageSubtitle}>
            All enquiries submitted through the contact form, in one place.
          </p>
        </div>
      </div>

      {contacts.length === 0 ? (
        <div style={styles.emptyState}>
          <h4 style={styles.emptyTitle}>No messages yet</h4>
          <p style={styles.emptyText}>
            Once visitors start sending enquiries, they will appear here as cards.
          </p>
        </div>
      ) : (
        <div style={styles.cardsGrid}>
          {contacts.map((contact) => (
            <div key={contact._id} style={styles.candidateCard}>
              <div style={styles.candidateHeader}>
                <div style={styles.candidateAvatar}>
                  <Users size={20} color="#4b5563" />
                </div>
                <div>
                  <h4 style={styles.candidateName}>{contact.name}</h4>
                  <p style={styles.candidateEmail}>{contact.email}</p>
                </div>
              </div>

              <div style={styles.candidateDetails}>
                <p style={styles.detailLine}>
                  <span style={styles.detailLabel}>Name:</span> {contact.name}
                </p>
                <p style={styles.detailLine}>
                  <span style={styles.detailLabel}>Email:</span> {contact.email}
                </p>
                <p style={styles.detailLine}>
                  <span style={styles.detailLabel}>Contact Number:</span> {contact.phone}
                </p>
                <p style={styles.detailLine}>
                  <span style={styles.detailLabel}>Message:</span>
                  <span style={styles.messageText}>{contact.message}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  pageWrapper: {
    padding: '24px',
    boxSizing: 'border-box',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '20px',
    gap: '16px',
  },
  pageTitle: {
    margin: 0,
    fontSize: '24px',
    fontWeight: 600,
    color: '#111827',
  },
  pageSubtitle: {
    marginTop: '4px',
    marginBottom: 0,
    fontSize: '13px',
    color: '#6b7280',
  },

  emptyState: {
    borderRadius: '14px',
    border: '1px dashed #d1d5db',
    padding: '28px 20px',
    textAlign: 'center',
    backgroundColor: '#f9fafb',
  },
  emptyTitle: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 600,
    color: '#111827',
  },
  emptyText: {
    marginTop: '6px',
    marginBottom: 0,
    fontSize: '14px',
    color: '#6b7280',
  },

  cardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '18px',
  },

  candidateCard: {
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 8px 20px rgba(15,23,42,0.06)',
    padding: '14px 16px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  candidateHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '4px',
  },
  candidateAvatar: {
    width: '36px',
    height: '36px',
    borderRadius: '999px',
    backgroundColor: '#e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  candidateName: {
    margin: 0,
    fontSize: '15px',
    fontWeight: 600,
    color: '#111827',
  },
  candidateEmail: {
    margin: 0,
    fontSize: '12px',
    color: '#6b7280',
  },

  candidateDetails: {
    fontSize: '13px',
    color: '#374151',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  detailLine: {
    margin: 0,
    lineHeight: 1.5,
  },
  detailLabel: {
    fontWeight: 600,
    color: '#111827',
    marginRight: '4px',
  },
  messageText: {
    display: 'block',
    marginTop: '2px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
};

export default Messages;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {Users} from 'lucide-react';

// const Messages = () => {

//    const [contacts, setContacts] = useState([]);

  

//     useEffect(() => {
//       const fetchcontacts = async () => {
//         try {
//           const res = await axios.get('/api/contacts');
//           setContacts(res.data);
//           //setLoading(false);
//         } catch (error) {
//           console.error("Error fetching members:", error);
//           //setLoading(false);
//         }
//       };
  
//       fetchcontacts();
//     }, []);

//   return (
    
//       <div style={styles.contentCard}>
//             <div style={styles.candidatesGrid}></div>
//         {contacts.map(contact => (
          
//           <div key={contact._id} style={styles.candidateCard}>
//                             <div style={styles.candidateHeader}>
//                               <div style={styles.candidateAvatar}>
//                                 <Users size={20} color="#6b7280" />
//                               </div>
//                               <div>
//                                 <h4 style={styles.candidateName}>{contact.name}</h4>
                               
//                               </div>
//                             </div>
//                             <div style={styles.candidateDetails}>
//                               <p><strong>Name:</strong> {contact.name}</p>
//                               <p><strong>Email:</strong> {contact.email}</p>
//                               <p><strong>Contact Number:</strong> {contact.phone}</p>
//                               <p><strong>Message:</strong> {contact.message}</p>
                             
//                             </div>
//                           </div>
//         ))}
//       </div>
    
//   );
// };

// const styles = {
//   contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//    candidatesGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//     gap: '16px'
//   },
//   candidateCard: {
//     border: '1px solid #e5e7eb',
//     borderRadius: '8px',
//     padding: '16px',
//     transition: 'box-shadow 0.2s ease',
//     cursor: 'pointer'
//   },
//   candidateHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     marginBottom: '12px'
//   },
//   candidateAvatar: {
//     width: '40px',
//     height: '40px',
//     backgroundColor: '#d1d5db',
//     borderRadius: '50%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   candidateName: {
//     fontWeight: '500',
//     margin: 0
//   },
//   candidateRole: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: 0
//   },
//   candidateDetails: {
//     fontSize: '14px',
//     color: '#6b7280',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px'
//   },
// }

// export default Messages;
